import React from "react"
import classNames from "classnames"

import { useTranslation } from "@/locales"
import { parseColorString } from "@/utils/i18n"
import Percent from "../Percent"

import styles from "./index.module.less"

interface ClearProps {
    index: number
    value: string
    className?: string
    style?: React.CSSProperties
}

const Clear: React.FC<ClearProps> = (props) => {
    const { index, value, className, style } = props
    const { t } = useTranslation()

    return (
        <div className={classNames(styles.clear, className)} style={style}>
            <div className={styles.stars}>
                {Array.from({ length: index }).map((_, index) => (
                    <div key={index} />
                ))}
            </div>
            <Percent value={value} className={styles.value} />
            <div className={styles.desc}>
                {parseColorString(t(`clear.${index}`)).map((item, index) => {
                    if (item.color) {
                        return (
                            <span key={index} className={styles.highlight}>
                                <span>{item.text}</span>
                            </span>
                        )
                    }

                    return <span key={index}>{item.text}</span>
                })}
            </div>
        </div>
    )
}

export default Clear
